const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBharatdcOn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "200px",
    height: "200px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2175f9",
    d: "M 86.5,-0.5 C 95.1667,-0.5 103.833,-0.5 112.5,-0.5C 120.75,0.896749 128.75,3.23008 136.5,6.5C 137.78,7.93127 139.447,8.59794 141.5,8.5C 145.655,9.74169 149.322,11.7417 152.5,14.5C 152.973,15.9063 153.973,16.573 155.5,16.5C 155.973,17.9063 156.973,18.573 158.5,18.5C 159.167,18.5 159.5,18.8333 159.5,19.5C 159.973,20.9063 160.973,21.573 162.5,21.5C 163.833,22.1667 164.833,23.1667 165.5,24.5C 168.167,27.8333 171.167,30.8333 174.5,33.5C 176.167,34.5 177.5,35.8333 178.5,37.5C 177.561,38.3274 177.895,38.9941 179.5,39.5C 181.326,41.1475 182.66,43.1475 183.5,45.5C 183.427,47.0269 184.094,48.0269 185.5,48.5C 186.338,48.8417 186.672,49.5084 186.5,50.5C 187.326,53.4848 188.659,56.1515 190.5,58.5C 194.888,67.0561 197.888,76.0561 199.5,85.5C 199.5,94.8333 199.5,104.167 199.5,113.5C 197.434,124.697 193.767,135.364 188.5,145.5C 187.094,145.973 186.427,146.973 186.5,148.5C 186.672,149.492 186.338,150.158 185.5,150.5C 184.094,150.973 183.427,151.973 183.5,153.5C 183.573,155.027 182.906,156.027 181.5,156.5C 180.094,156.973 179.427,157.973 179.5,159.5C 179.5,160.167 179.167,160.5 178.5,160.5C 177.094,160.973 176.427,161.973 176.5,163.5C 175.833,164.833 174.833,165.833 173.5,166.5C 170.833,168.5 168.5,170.833 166.5,173.5C 165.5,175.167 164.167,176.5 162.5,177.5C 160.973,177.427 159.973,178.094 159.5,179.5C 159.5,180.167 159.167,180.5 158.5,180.5C 156.973,180.427 155.973,181.094 155.5,182.5C 154.341,184.25 152.674,185.25 150.5,185.5C 148.973,185.427 147.973,186.094 147.5,187.5C 145.819,189.008 143.819,190.008 141.5,190.5C 139.447,190.402 137.78,191.069 136.5,192.5C 134.04,193.891 131.374,195.058 128.5,196C 123.035,197.204 117.701,198.37 112.5,199.5C 103.833,199.5 95.1667,199.5 86.5,199.5C 81.2985,198.37 75.9652,197.204 70.5,196C 67.6262,195.058 64.9596,193.891 62.5,192.5C 61.2196,191.069 59.5529,190.402 57.5,190.5C 55.1815,190.008 53.1815,189.008 51.5,187.5C 51.0269,186.094 50.0269,185.427 48.5,185.5C 46.326,185.25 44.6594,184.25 43.5,182.5C 42.9941,180.895 42.3274,180.561 41.5,181.5C 40.5,181.167 39.8333,180.5 39.5,179.5C 38.9941,177.895 38.3274,177.561 37.5,178.5C 35.5,177.167 33.8333,175.5 32.5,173.5C 30.5,170.833 28.1667,168.5 25.5,166.5C 24.1667,165.833 23.1667,164.833 22.5,163.5C 22.573,161.973 21.9063,160.973 20.5,160.5C 19.8333,160.5 19.5,160.167 19.5,159.5C 19.573,157.973 18.9063,156.973 17.5,156.5C 15.0499,154.371 13.3833,151.704 12.5,148.5C 12.573,146.973 11.9063,145.973 10.5,145.5C 10.5979,143.447 9.93127,141.78 8.5,140.5C 4.11236,131.944 1.11236,122.944 -0.5,113.5C -0.5,104.167 -0.5,94.8333 -0.5,85.5C 1.08349,76.837 3.75016,68.5036 7.5,60.5C 8.93127,59.2196 9.59794,57.5529 9.5,55.5C 9.32842,54.5084 9.66175,53.8417 10.5,53.5C 11.9063,53.0269 12.573,52.0269 12.5,50.5C 12.3284,49.5084 12.6618,48.8417 13.5,48.5C 14.9063,48.0269 15.573,47.0269 15.5,45.5C 16.3403,43.1475 17.6736,41.1475 19.5,39.5C 21.1054,38.9941 21.4387,38.3274 20.5,37.5C 21.5,35.8333 22.8333,34.5 24.5,33.5C 27.8333,30.8333 30.8333,27.8333 33.5,24.5C 34.1667,23.1667 35.1667,22.1667 36.5,21.5C 38.0269,21.573 39.0269,20.9063 39.5,19.5C 39.5,18.8333 39.8333,18.5 40.5,18.5C 42.0269,18.573 43.0269,17.9063 43.5,16.5C 45.0269,16.573 46.0269,15.9063 46.5,14.5C 49.678,11.7417 53.3447,9.74169 57.5,8.5C 59.5529,8.59794 61.2196,7.93127 62.5,6.5C 70.2498,3.23008 78.2498,0.896749 86.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.435
    },
    fill: "#485d0f",
    d: "M 62.5,6.5 C 61.2196,7.93127 59.5529,8.59794 57.5,8.5C 58.7804,7.06873 60.4471,6.40206 62.5,6.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.435
    },
    fill: "#43560f",
    d: "M 136.5,6.5 C 138.553,6.40206 140.22,7.06873 141.5,8.5C 139.447,8.59794 137.78,7.93127 136.5,6.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.863
    },
    fill: "#567010",
    d: "M 46.5,14.5 C 46.0269,15.9063 45.0269,16.573 43.5,16.5C 43.9731,15.0937 44.9731,14.427 46.5,14.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.255
    },
    fill: "#38480d",
    d: "M 152.5,14.5 C 154.027,14.427 155.027,15.0937 155.5,16.5C 153.973,16.573 152.973,15.9063 152.5,14.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.02
    },
    fill: "#2e3a10",
    d: "M 155.5,16.5 C 157.027,16.427 158.027,17.0937 158.5,18.5C 156.973,18.573 155.973,17.9063 155.5,16.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.8
    },
    fill: "#4d6412",
    d: "M 43.5,16.5 C 43.0269,17.9063 42.0269,18.573 40.5,18.5C 40.9731,17.0937 41.9731,16.427 43.5,16.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.031
    },
    fill: "#313e10",
    d: "M 159.5,19.5 C 161.027,19.427 162.027,20.0937 162.5,21.5C 160.973,21.573 159.973,20.9063 159.5,19.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.831
    },
    fill: "#516913",
    d: "M 39.5,19.5 C 39.0269,20.9063 38.0269,21.573 36.5,21.5C 36.9731,20.0937 37.9731,19.427 39.5,19.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.012
    },
    fill: "#3b4a12",
    d: "M 165.5,24.5 C 169.5,26.5 172.5,29.5 174.5,33.5C 171.167,30.8333 168.167,27.8333 165.5,24.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.651
    },
    fill: "#495d13",
    d: "M 33.5,24.5 C 30.8333,27.8333 27.8333,30.8333 24.5,33.5C 26.5,29.5 29.5,26.5 33.5,24.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.02
    },
    fill: "#354311",
    d: "M 178.5,37.5 C 179.338,37.8417 179.672,38.5084 179.5,39.5C 177.895,38.9941 177.561,38.3274 178.5,37.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.565
    },
    fill: "#4b6011",
    d: "M 20.5,37.5 C 21.4387,38.3274 21.1054,38.9941 19.5,39.5C 19.3284,38.5084 19.6618,37.8417 20.5,37.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.565
    },
    fill: "#4d6211",
    d: "M 15.5,45.5 C 15.573,47.0269 14.9063,48.0269 13.5,48.5C 13.427,46.9731 14.0937,45.9731 15.5,45.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.565
    },
    fill: "#4c6210",
    d: "M 183.5,45.5 C 184.906,45.9731 185.573,46.9731 185.5,48.5C 184.094,48.0269 183.427,47.0269 183.5,45.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.502
    },
    fill: "#485c10",
    d: "M 12.5,50.5 C 12.573,52.0269 11.9063,53.0269 10.5,53.5C 10.427,51.9731 11.0937,50.9731 12.5,50.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fafcf1",
    d: "M 74.5,51.5 C 75.4959,51.4142 76.3292,51.7476 77,52.5C 77.4935,54.1341 77.6602,55.8008 77.5,57.5C 91.8333,57.5 106.167,57.5 120.5,57.5C 120.5,55.5 120.5,53.5 120.5,51.5C 133.119,56.6199 141.952,65.6199 147,78.5C 155.513,109.987 145.013,132.487 115.5,146C 93.4841,152.288 74.6508,147.122 59,130.5C 46.897,114.338 44.2303,96.6717 51,77.5C 56.3119,66.3643 64.1452,57.6976 74.5,51.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.376
    },
    fill: "#465a10",
    d: "M 186.5,50.5 C 188.873,52.5792 190.206,55.2459 190.5,58.5C 188.659,56.1515 187.326,53.4848 186.5,50.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.345
    },
    fill: "#3c4c0e",
    d: "M 9.5,55.5 C 9.59794,57.5529 8.93127,59.2196 7.5,60.5C 7.40206,58.4471 8.06873,56.7804 9.5,55.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1775fe",
    d: "M 76.5,62.5 C 91.5037,62.3334 106.504,62.5001 121.5,63C 138.816,76.5503 143.65,93.717 136,114.5C 125.486,133.173 109.652,140.673 88.5,137C 65.3366,128.492 55.5032,111.992 59,87.5C 60.4491,82.6012 62.4491,77.9346 65,73.5C 68.7288,69.6019 72.5621,65.9352 76.5,62.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f7faeb",
    d: "M 78.5,67.5 C 84.1878,66.3436 88.1878,68.3436 90.5,73.5C 92.8168,68.1768 96.8168,66.3435 102.5,68C 107.833,72.6667 107.833,77.3333 102.5,82C 96.8168,83.6565 92.8168,81.8232 90.5,76.5C 88.1832,81.8232 84.1832,83.6565 78.5,82C 73.232,77.1706 73.232,72.3373 78.5,67.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f8fbed",
    d: "M 111.5,67.5 C 121.855,67.0383 124.855,71.5383 120.5,81C 111.087,84.579 106.92,81.4123 108,71.5C 108.69,69.6498 109.856,68.3164 111.5,67.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1775fe",
    d: "M 81.5,73.5 C 83.9732,73.9473 84.1399,74.9473 82,76.5C 81.5172,75.552 81.3505,74.552 81.5,73.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1775fe",
    d: "M 97.5,73.5 C 99.2252,73.8425 99.7252,74.8425 99,76.5C 97.9614,75.7562 97.4614,74.7562 97.5,73.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1775fe",
    d: "M 114.5,73.5 C 116.76,74.2376 116.927,75.2376 115,76.5C 113.272,75.6477 113.105,74.6477 114.5,73.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f5f9e5",
    d: "M 96.5,83.5 C 104.168,83.3321 107.335,86.9988 106,94.5C 102.914,99.7522 98.7471,100.752 93.5,97.5C 89.11,91.7227 90.11,87.056 96.5,83.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f5f9e4",
    d: "M 70.5,86.5 C 79.5789,86.5418 84.9122,91.0418 86.5,100C 83.4372,112.198 76.1039,115.865 64.5,111C 58.271,104.275 57.9377,97.2748 63.5,90C 65.9252,88.7874 68.2585,87.6207 70.5,86.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f4f8e2",
    d: "M 122.5,86.5 C 136.12,87.7525 140.62,94.7525 136,107.5C 130.472,113.957 123.972,115.124 116.5,111C 108.428,100.314 110.428,92.147 122.5,86.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1775fe",
    d: "M 97.5,90.5 C 99.337,90.6395 99.6704,91.3061 98.5,92.5C 97.7025,92.0431 97.3691,91.3764 97.5,90.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1775fe",
    d: "M 69.5,92.5 C 75.9047,91.5266 79.5714,94.1933 80.5,100.5C 79.1895,106.643 75.5228,108.809 69.5,107C 66.4191,105.688 64.7524,103.355 64.5,100C 65.3106,96.8646 66.9772,94.3646 69.5,92.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1775fe",
    d: "M 122.5,92.5 C 129.657,92.155 132.824,95.4884 132,102.5C 129.928,107.143 126.428,108.643 121.5,107C 117.788,104.487 116.622,100.987 118,96.5C 119.397,94.9297 120.897,93.5964 122.5,92.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f5f9e6",
    d: "M 95.5,111.5 C 105.337,111.168 109.837,115.835 109,125.5C 105.804,132.344 100.638,134.51 93.5,132C 90.5379,129.713 88.3712,126.88 87,123.5C 83.959,130.514 79.2923,131.847 73,127.5C 69.7851,118.42 72.9518,114.253 82.5,115C 85.1083,116.378 86.6083,118.545 87,121.5C 88.2613,116.745 91.0947,113.412 95.5,111.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f8fbec",
    d: "M 115.5,114.5 C 124.61,114.772 127.443,119.105 124,127.5C 118.919,131.695 114.586,131.029 111,125.5C 109.393,120.438 110.893,116.772 115.5,114.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1775fe",
    d: "M 96.5,117.5 C 102.989,117.156 104.989,119.99 102.5,126C 96.7441,128.569 93.9108,126.736 94,120.5C 94.6979,119.309 95.5313,118.309 96.5,117.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1775fe",
    d: "M 78.5,121.5 C 80.337,121.639 80.6704,122.306 79.5,123.5C 78.7025,123.043 78.3691,122.376 78.5,121.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1775fe",
    d: "M 116.5,122.5 C 117.386,121.224 118.386,121.224 119.5,122.5C 118.575,123.562 117.575,123.562 116.5,122.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.439
    },
    fill: "#445610",
    d: "M 8.5,140.5 C 9.93127,141.78 10.5979,143.447 10.5,145.5C 9.06873,144.22 8.40206,142.553 8.5,140.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.345
    },
    fill: "#40520e",
    d: "M 10.5,145.5 C 11.9063,145.973 12.573,146.973 12.5,148.5C 11.0937,148.027 10.427,147.027 10.5,145.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.345
    },
    fill: "#3f510e",
    d: "M 188.5,145.5 C 188.573,147.027 187.906,148.027 186.5,148.5C 186.427,146.973 187.094,145.973 188.5,145.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.345
    },
    fill: "#41530e",
    d: "M 185.5,150.5 C 185.573,152.027 184.906,153.027 183.5,153.5C 183.427,151.973 184.094,150.973 185.5,150.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.059
    },
    fill: "#394811",
    d: "M 17.5,156.5 C 18.9063,156.973 19.573,157.973 19.5,159.5C 18.0937,159.027 17.427,158.027 17.5,156.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.059
    },
    fill: "#384711",
    d: "M 181.5,156.5 C 181.573,158.027 180.906,159.027 179.5,159.5C 179.427,157.973 180.094,156.973 181.5,156.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.059
    },
    fill: "#374711",
    d: "M 20.5,160.5 C 21.9063,160.973 22.573,161.973 22.5,163.5C 21.0937,163.027 20.427,162.027 20.5,160.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.059
    },
    fill: "#384711",
    d: "M 178.5,160.5 C 178.573,162.027 177.906,163.027 176.5,163.5C 176.427,161.973 177.094,160.973 178.5,160.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#3b4a12",
    d: "M 25.5,166.5 C 28.1667,168.5 30.5,170.833 32.5,173.5C 29.1667,172.167 26.8333,169.833 25.5,166.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.071
    },
    fill: "#323e11",
    d: "M 173.5,166.5 C 172.167,169.833 169.833,172.167 166.5,173.5C 168.5,170.833 170.833,168.5 173.5,166.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.012
    },
    fill: "#344111",
    d: "M 39.5,179.5 C 38.5084,179.672 37.8417,179.338 37.5,178.5C 38.3274,177.561 38.9941,177.895 39.5,179.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.012
    },
    fill: "#252d0e",
    d: "M 162.5,177.5 C 162.027,178.906 161.027,179.573 159.5,179.5C 159.973,178.094 160.973,177.427 162.5,177.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.024
    },
    fill: "#354311",
    d: "M 43.5,182.5 C 42.5084,182.672 41.8417,182.338 41.5,181.5C 42.3274,180.561 42.9941,180.895 43.5,182.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.012
    },
    fill: "#252d0e",
    d: "M 158.5,180.5 C 158.027,181.906 157.027,182.573 155.5,182.5C 155.973,181.094 156.973,180.427 158.5,180.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.471
    },
    fill: "#44570f",
    d: "M 48.5,185.5 C 50.0269,185.427 51.0269,186.094 51.5,187.5C 49.9731,187.573 48.9731,186.906 48.5,185.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.027
    },
    fill: "#2b360d",
    d: "M 150.5,185.5 C 150.027,186.906 149.027,187.573 147.5,187.5C 147.973,186.094 148.973,185.427 150.5,185.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.431
    },
    fill: "#3e4f10",
    d: "M 141.5,190.5 C 140.22,191.931 138.553,192.598 136.5,192.5C 137.78,191.069 139.447,190.402 141.5,190.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4
    },
    fill: "#425510",
    d: "M 57.5,190.5 C 59.5529,190.402 61.2196,191.069 62.5,192.5C 60.4471,192.598 58.7804,191.931 57.5,190.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBharatdcOn);
export default __webpack_public_path__ + "static/media/BHARATDC-on.d7c79a649c68f34b579e3ade4353ba7e.svg";
export { ForwardRef as ReactComponent };